import * as Data from '../api/archibus-v2/DataApi'
import * as Document from '../api/archibus/DocumentApi'

export const fetchEquipment = ({eqId}) => {
  let equipment = {}
  let restriction = new Ab.view.Restriction()
  restriction.addClause('eq.eq_id', eqId)
  return Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'equipmentInfo',
    restriction
  )
    .then(result => {
      const {data} = result
      equipment = data[0]

      if (equipment.docGraphic) {
        return Document.getTempDocumentUrl(
          'eqstd',
          {eq_std: equipment.eqStd},
          'doc_graphic'
        )
      } else {
        return Promise.resolve(null)
      }
    })
    .then(url => {
      equipment.imageUrl = url || null
      return Promise.resolve(equipment)
    })
}
/*
export const fetchEquipmentRooms = ({blId, flId}) => {
      let restriction = new Ab.view.Restriction()
      restriction.addClause('eq.bl_id', blId)
      restriction.addClause('eq.fl_id', flId)
      return Data.getDataFromDataSource(
        'ab-self-service.axvw',
        'equipmentInfo',
        restriction
      ).then(result => {
          const {data} = result
          return Promise.all(
          data.map(item => {
                if (item.docGraphic) {
                    return Document.getTempDocumentUrl(
                          'eqstd',
                          {eq_std: item.eqStd},
                          'doc_graphic'
                    ).then(url => {
                      item.url = encodeURI(url)
                      return Promise.resolve(item)
                    })
                  } else {
                    return Promise.resolve({...item, url: null})
                  }
                })
           )		   
    })
}
*/

export const fetchEquipmentRooms = ({blId, flId, eqStd}) => {
      let restriction = new Ab.view.Restriction()
      restriction.addClause('eq.bl_id', blId)
      restriction.addClause('eq.fl_id', flId)
	  if (eqStd) {
		  restriction.addClause('eq.eq_std', eqStd)
	  }
      return Data.getDataFromDataSource(
        'ab-self-service.axvw',
        'equipmentInfo',
        restriction
      ).then(result => {
          const {data} = result
          return Promise.all(
          data.map(item => {
                if (item.docGraphic) {
                    return Document.getTempDocumentUrl(
                          'eqstd',
                          {eq_std: item.eqStd},
                          'doc_graphic'
                    ).then(url => {
                      item.url = encodeURI(url)
                      return Promise.resolve(item)
                    })
                  } else {
                    return Promise.resolve({...item, url: null})
                  }
                })
           )		   
    })
}

export const fetchFloorEquipmentStandards = ({blId, flId}) => {
      let restriction = new Ab.view.Restriction()
      restriction.addClause('eq.bl_id', blId)
      restriction.addClause('eq.fl_id', flId)
      return Data.getDataFromDataSource(
        'ab-self-service.axvw',
        'eqstdsPerFloor',
        restriction
      ).then(result => {
          const {data} = result
          return Promise.all(
          data.map(item => {
                if (item.docGraphic) {
                    return Document.getTempDocumentUrl(
                          'eqstd',
                          {eq_std: item.eqStd},
                          'doc_graphic'
                    ).then(url => {
                      item.url = encodeURI(url)
                      return Promise.resolve(item)
                    })
                  } else {
                    return Promise.resolve({...item, url: null})
                  }
                })
           )		   
    })
}
